import React, { Component } from "react";
import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import RefreshLogo from "../../images/RefreshLogo.png";

class Table extends Component {
	constructor(props) {
		super(props);
	}

	createRecordLabel = (page, sizePerPage, totalSize, data) => {
		var from = data.length === 0 ? 0 : (page - 1) * sizePerPage + 1;
		var to = (page - 1) * sizePerPage + data.length;
		return (
			<span>
				{from} to {to} of {totalSize} Results
			</span>
		);
	};

	render() {
		const { ExportCSVButton } = CSVExport;

		const { showPdf = true } = this.props;

		const indication = () => {
			return (
				<span>
					<span hidden={this.props.loading}>
						<span
							className="fa fa-exclamation-triangle"
							style={{ marginRight: "10px" }}
						></span>
						No data available
					</span>
					<span hidden={!this.props.loading}>
						<span
							className="fa fa-spinner fa-spin"
							style={{ marginRight: "10px" }}
						></span>
						Loading...
					</span>
				</span>
			);
		};
		const customTotal = (from, to, size) => (
			<span className="react-bootstrap-table-pagination-total">
				{/*Showing { from } to { to } of { size } Results*/}
			</span>
		);

		const RemotePagination = ({
			data,
			page,
			sizePerPage,
			onTableChange,
			totalSize,
			columns,
		}) => (
			<div>
				<PaginationProvider
					pagination={paginationFactory({
						custom: false,
						page,
						totalSize,
						firstPageText: "First",
						sizePerPage,
						prePageText: "Back",
						nextPageText: "Next",
						lastPageText: "Last",
						nextPageTitle: "First page",
						prePageTitle: "Pre page",
						firstPageTitle: "Next page",
						lastPageTitle: "Last page",
						hidePageListOnlyOnePage: true,
						showTotal: true,
						// paginationTotalRenderer: customTotal,
						sizePerPageList: [
							{
								text: "15",
								value: 15,
							},
							{
								text: "30",
								value: 30,
							},
							{
								text: "50",
								value: 50,
							},
							{
								text: "200",
								value: 200,
							},
						],
					})}
				>
					{({ paginationProps, paginationTableProps }) => (
						<>
							<div className="row mb-2">
								<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-12">
									<button
										onClick={() => {
											this.props.RefreshTable();
										}}
										data-toggle="tooltip"
										title="Refresh"
										className="btn TableRow_btn"
										style={{ padding: "0px 7px" }}
									>
										<img src={RefreshLogo} />
									</button>
									<span
										style={{
											borderRight: "2px solid #D7D7D7",
											paddingRight: "10px",
											marginRight: "10px",
											fontSize: "13px",
										}}
									>
										{this.createRecordLabel(page, sizePerPage, totalSize, data)}
									</span>
								</div>
								{this.props?.exportAllowed && (
									<>
										<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-12 text-right">
											<span
												onClick={() => {
													$(".react-bs-table-csv-btn").click();
												}}
												className="TableExport_button"
											>
												<i className="fa fa-download" aria-hidden="true"></i> Export
											</span>
											<span
												onClick={() => {
													this.props.changeSizePerPage(totalSize, 1);
												}}
												className="TableExport_button"
											>
												<i className="fa fa-download" aria-hidden="true"></i>{" "}
												{this.props.exportLoading
													? " Exporting..."
													: " Export All"}
											</span>
											{/* {showPdf && (
                        <span
                          onClick={this.props.exportPdf}
                          className="TableExport_button"
                        >
                          <i className="fa fa-download" aria-hidden="true"></i>
                          {this.props?.pdfExportLoading
                            ? ' Exporting...'
                            : ' Export Pdf'}
                        </span>
                      )} */}
										</div>
									</>
								)}
							</div>
							<ToolkitProvider
								keyField={this.props.keyField}
								data={data}
								columns={columns}
								exportCSV={{
									fileName: this.props.csvFileName || 'spreadsheet.csv'
								}}
								bootstrap4
							>
								{(props) => (
									<div>
										<div style={{ display: "none" }}>
											<ExportCSVButton {...props.csvProps}>
												Export CSV
											</ExportCSVButton>
										</div>
										<BootstrapTable
											rowClasses="Table-hover-row"
											loading={this.props.loading}
											remote
											{...paginationTableProps}
											{...props.baseProps}
											onTableChange={onTableChange}
											headerClasses="header-class"
											rowEvents={this.props.rowEvents}
											striped={true}
											selectRow={this.props.selectRow}
											noDataIndication={indication}
											hover={true}
										/>
										{/* overlay={overlayFactory({ strpied: true })} */}
									</div>
								)}
							</ToolkitProvider>
						</>
					)}
				</PaginationProvider>
			</div>
		);

		const options = {
			paginationSize: 4,
			pageStartIndex: 0,
			//alwaysShowAllBtns: true, // Always show next and previous button
			// withFirstAndLast: false, // Hide the going to First and Last page button
			// hideSizePerPage: true, // Hide the sizePerPage dropdown always
			hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
			firstPageText: "First",
			prePageText: "Back",
			nextPageText: "Next",
			lastPageText: "Last",
			nextPageTitle: "First page",
			prePageTitle: "Pre page",
			firstPageTitle: "Next page",
			lastPageTitle: "Last page",
			showTotal: true,
			paginationTotalRenderer: customTotal,
			sizePerPageList: [
				{
					text: "15",
					value: 15,
				},
				{
					text: "30",
					value: 30,
				},
				{
					text: "All",
					value: this.props.data.length,
				},
			], // A numeric array is also available. the purpose of above example is custom the text
		};

		return (
			<div>
				{this.props.isPagination === undefined || this.props.isPagination ? (
					<RemotePagination
						data={this.props.data}
						page={this.props.page}
						sizePerPage={this.props.sizePerPage}
						totalSize={this.props.totalSize}
						onTableChange={this.props.onTableChange}
						columns={this.props.columns}
					/>
				) : (
					<ToolkitProvider
						keyField={this.props.keyField}
						data={this.props.data}
						columns={this.props.columns}
						exportCSV={{
							fileName: this.props.csvFileName || 'spreadsheet.csv'
						}}
					>
						{(props) => (
							<div>
								<BootstrapTable
									{...props.baseProps}
									loading={this.props.loading}
									rowEvents={this.props.rowEvents}
									headerClasses="header-class"
									rowClasses="Table-hover-row"
									selectRow={this.props.selectRow}
									pagination={paginationFactory(options)}
									noDataIndication={indication}
									onTableChange={this.props.onTableChange}
									bordered={false}
								/>
							</div>
						)}
					</ToolkitProvider>
				)}
			</div>
		);
	}

	componentDidMount() { }
}

export default Table;
